import { createFileRoute } from '@tanstack/react-router'
import { ManagerDashboard } from '@/common/components/manager-dashboard/ManagerDashboard'

export const Route = createFileRoute('/manager/')({
  component: ManagerDashboard,
})
